export default "__VITE_ASSET__DY65Xej4__"